import AfSwitch from '@/components/AfSwitch';
import GoBackMenu from '@/components/GoBackNavbar';
import Loader from '@/components/Loader';
import Upload from '@/components/Upload';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { setConfigRequest } from '@/store/appOrganization/action';
import React, { useEffect, useState } from 'react';
import { ChromePicker, ColorResult } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

const Customization = () => {
    const [color, setColor] = useState<string>('');
    const [logo, setLogo] = useState<string>('');
    const [logoChanged, setLogoChanged] = useState<boolean>(false);
    const [banner, setBanner] = useState<string | undefined>(undefined);
    const [hasBanner, setHasBanner] = useState(false);
    const [bannerChanged, setBannerChanged] = useState<boolean>(false);
    const [validHex, setValidHex] = useState<boolean>(false);
    const [displayColorPicker, setDisplayColorPicker] = useState<boolean>(false);
    const [bannerActivated, setBannerActivated] = useState<boolean>(false);
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const {
        data: { colors, organization, application, isWhiteLabel, dynamicAttributes },
        loading,
    } = useSelector((state: ApplicationState) => state.appOrganization);

    const dispatch = useDispatch();

    useEffect(() => {
        setLogo(`${Constants.ORG_LOGO.replace('%s', organization.orgKey).replace('%s', application.key.toLowerCase())}?force=${Date.now()}`);

        if (dynamicAttributes.hasBanner) {
            setHasBanner(dynamicAttributes.hasBanner);
            setBanner(`${Constants.ORG_BANNER.replace('%s', organization.orgKey).replace('%s', application.key.toLowerCase())}?force=${Date.now()}`);
            setBannerActivated(dynamicAttributes.bannerActivated);
        }
    }, [organization.orgKey, application.key, dynamicAttributes]);

    useEffect(() => {
        if (colors && colors.length > 0) {
            setColor(colors[0]);
            setValidHex(true);
        }
    }, [colors]);

    const handleHexChanged = (value: string) => {
        setColor(value);
        const isValid = /^#([0-9A-F]{3}){1,2}$/i.test(value);
        setValidHex(isValid);
    };

    const handleSubmit = () => {
        dispatch(
            setConfigRequest({
                color,
                bannerActivated,
                logo: logoChanged ? logo : undefined,
                banner: bannerChanged ? banner : undefined,
                hasBanner,
            }),
        );

        setBannerChanged(false);
    };

    const handleClick = () => {
        setDisplayColorPicker(!displayColorPicker);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
    };

    const handleChange = (color: ColorResult) => {
        setColor(color.hex.toUpperCase());
    };

    return (
        <>
            <GoBackMenu />
            <div className="config-custom">
                <div className="title">
                    <h1>{strings.CONFIGURATIONS}</h1>
                </div>
                <div className="card">
                    <span className="card-title">{strings.SYSTEM_CUSTOMIZATION}</span>
                    <div className="subtitle-container">
                        <span className="card-subtitle">{strings.LOGO_ORG_LABEL}</span>
                        <span className="card-subtitle small">({strings.MAX_SIZE}: 200x50px)</span>
                    </div>
                    <Upload
                        isLogo
                        onComplete={({ key }) => {
                            setLogoChanged(true);
                            setLogo(key);
                        }}
                        onRemove={() => {
                            setLogoChanged(false);
                            setLogo('');
                        }}
                        previewFile={{ uri: logo, name: 'org-logo.png' }}
                        typeAccepted="IMAGE"
                    />

                    {isWhiteLabel && (
                        <>
                            <div className="subtitle-container">
                                <span className="card-subtitle">{strings.BANNER_ORG_FOR_HOME_LABEL}</span>
                                <span className="card-subtitle small">({strings.MAX_SIZE}: 960x200px)</span>
                            </div>
                            <Upload
                                isBanner
                                onComplete={({ key }) => {
                                    setBanner(key);
                                    setBannerChanged(true);
                                    setBannerActivated(true);
                                    setHasBanner(true);
                                }}
                                onRemove={() => {
                                    setBannerChanged(false);
                                    setBanner('');
                                    setHasBanner(false);
                                }}
                                previewFile={{ uri: banner, name: 'org-banner.png' }}
                                typeAccepted="IMAGE"
                            />
                            {!!banner && (
                                <div className="banner-switch-container">
                                    <AfSwitch
                                        checked={bannerActivated}
                                        onChange={() => {
                                            setBannerActivated(!bannerActivated);
                                        }}
                                    />
                                    <span>{bannerActivated ? strings.ACTIVE : strings.INACTIVE}</span>
                                </div>
                            )}
                        </>
                    )}

                    <span className="card-subtitle">Selecione a cor primaria</span>
                    <div className="form-group inner-addon left-addon">
                        <button className="input-icon" onClick={handleClick}>
                            <i className="material-icons-outlined align-middle">{Constants.icons.COLORIZE}</i>
                        </button>
                        {displayColorPicker && (
                            <div className="color-picker-popover">
                                <div className="color-picker-cover" onClick={handleClose} />
                                <ChromePicker color={color} disableAlpha onChange={(color) => handleChange(color)} />
                            </div>
                        )}

                        <input
                            className="form-control color-hex"
                            onChange={(e) => handleHexChanged(e.target.value)}
                            placeholder={color}
                            type="text"
                            value={color}
                        />
                    </div>
                    <div className="submit-buttons">
                        {loading && <Loader styles={{ padding: 0 }} />}
                        {!loading && (
                            <button className="btn btn-primary btn-sm" disabled={logo.length <= 0 || !validHex} onClick={handleSubmit} type="button">
                                {strings.SAVE}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Customization;
